/**
 * @generated SignedSource<<6411dd11629a1df7f88d6062b59e23cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSellerInformation_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedMeetTheSeller_user">;
  readonly " $fragmentType": "PdpRespSellerInformation_user";
};
export type PdpRespSellerInformation_user$key = {
  readonly " $data"?: PdpRespSellerInformation_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSellerInformation_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSellerInformation_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedMeetTheSeller_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "f39316251171aa674852bf7b952c69f2";

export default node;
